export function IsImage(file: File) {
    const imageMimeTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/bmp',
        'image/webp',
        'image/tiff',
        'image/svg+xml',
    ];
    return imageMimeTypes.includes(file.type);
}

export async function ResizeImageFile(imageFile: File, maxSize: number, quality: number): Promise<File> {
    const image = await fileToImageElement(imageFile);

    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (!ctx) {
            reject(new Error('Failed to create canvas context'));
            return;
        }

        let width = image.width;
        let height = image.height;

        if (width < maxSize && height < maxSize) {
            resolve(imageFile);
            return;
        }

        if (width > height) {
            if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
            }
        } else {
            if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
            }
        }

        canvas.width = width;
        canvas.height = height;

        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.drawImage(image, 0, 0, width, height);

        canvas.toBlob(
            blob => {
                if (!blob) {
                    reject(new Error('Failed to create resized image Blob'));
                    return;
                }

                const resizedImageFile = new File([blob], imageFile.name, {
                    type: imageFile.type,
                });
                resolve(resizedImageFile);
            },
            imageFile.type,
            quality
        );
    });
}

function fileToImageElement(file: File): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = event => {
            const image = new Image();
            image.src = event.target?.result as string;
            image.onload = () => resolve(image);
            image.onerror = () => reject(new Error('Failed to load image'));
        };
        reader.onerror = () => reject(new Error('Failed to read image file'));
        reader.readAsDataURL(file);
    });
}
